module.exports = __webpack_public_path__ + "img/jq_image.e17c2a04.png";